import { UPDATE_PERMISSION, FULL_PERMISSION, READ_PERMISSION, DELETE_PERMISSION } from 'settings/constants/roles'

// Later add to Constants.js file
const IS_ROLE_CHECK = true

export const hasReadPermissions = (code: number) => {
  if (IS_ROLE_CHECK) {
    return code >= READ_PERMISSION
  }

  return true
}

/**
 * Strict equality against CrudType.CREATE, so a user at CrudType.DELETE (the level *above*) fails
 * this check. Preserved as-is because every existing caller depends on the current behaviour —
 * prefer `hasCreatePermissions` for new code.
 */
export const hasAddPermissions = (code: number) => {
  if (IS_ROLE_CHECK) {
    return code === FULL_PERMISSION
  }

  return true
}

export const hasUpdatePermissions = (code: number) => {
  if (IS_ROLE_CHECK) {
    return code >= UPDATE_PERMISSION
  }

  return true
}

/** Ladder-correct create check — CrudType.DELETE implies CREATE. */
export const hasCreatePermissions = (code: number) => {
  if (IS_ROLE_CHECK) {
    return code >= FULL_PERMISSION
  }

  return true
}

export const hasDeletePermissions = (code: number) => {
  if (IS_ROLE_CHECK) {
    return code >= DELETE_PERMISSION
  }

  return true
}
